// extracted by mini-css-extract-plugin
export default {"searchLocationBar":"style_searchLocationBar__g2HBK"};